import { IOption } from "../../../../types";

export const getDepartmentOption = ({
  departmentValue,
  departmentOptions,
}: {
  departmentValue: string;
  departmentOptions: IOption[];
}): IOption => {
  return (
    departmentOptions.find(
      (department) => department.value === departmentValue,
    ) || { label: departmentValue, value: departmentValue }
  );
};